import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Modal } from "antd";
import Button from "./Button"; // Adjust the import path for your custom Button component
import { useNavigate } from "react-router-dom";

const MyModal = forwardRef(
  (
    {
      title,
      message,
      imageSrc,
      confirmText,
      onConfirm,
      navigatePath,
      additionalContent,
    },
    ref
  ) => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Expose methods to parent component using ref
    useImperativeHandle(ref, () => ({
      showModal() {
        setIsModalOpen(true);
      },
      hideModal() {
        setIsModalOpen(false);
      },
    }));

    const handleConfirm = () => {
      if (navigatePath) {
        navigate(navigatePath);
      } else if (onConfirm) {
        onConfirm();
      }
      setIsModalOpen(false);
    };

    return (
      <Modal footer={null} open={isModalOpen} onCancel={handleConfirm}>
        <div className="modal">
          <div className="modal-img-container">
            {imageSrc && <img src={imageSrc} alt="Modal Icon" />}
          </div>
          {title && <h5>{title}</h5>}
          {message && <h6>{message}</h6>}
          {confirmText && (
            <Button onClick={handleConfirm}>{confirmText || "Confirm"}</Button>
          )}
          {additionalContent}
        </div>
      </Modal>
    );
  }
);

export default MyModal;
